/**
* @Author: zachalam
* @Date:   2017-03-14T13:45:27-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-15T15:14:30-07:00
*/

import React, { Component } from 'react';

import Container from '../../blocks/Container';
import { css, StyleSheet } from 'aphrodite/no-important';
import { dimensions, spacing, type, borders } from '../../../style';
import Panel from '../../common/Panel';
import Header from '../../blocks/Header'
import Headline from '../../common/Headline'
import _ from 'lodash';

const style = StyleSheet.create({
  lineItem: {
    display: 'table',
    ...type.MD,
    ...spacing.PADDING_SM,
    borderBottom: borders.DEFAULT,
    [':last-child']: {
      borderBottomWidth: '0'
    }
  },

  cell: {
    display: 'table-cell',
    [':first-child']: {
      width: '10000px'
    }
  }
})

class BillingHistory extends Component {

  renderPaymentHistory(payments) {
    // loop through each mail item.
    if(!_.isEmpty(payments)) {
      var paymentList = Object.keys(payments).map((key) => {

        let thePayment = payments[key];
        let thePackage = thePayment.package.data;
        //console.log(thePayment);
        //console.log(thePackage);

        return (
            <div className={css(style.lineItem)}>
              <div className={css(style.cell)}>
                  {thePackage.description}
              </div>
              <div className={css(style.cell)}>
                {thePayment.charge_amt}
              </div>
            </div>
        );
      })
      return paymentList;
    }
  }

  render() {


    let payments = this.props.payments;


    if(payments)
    {



      return (
        <div>
          <Container>
            <Header>
              <Headline>Payment History</Headline>
            </Header>
          </Container>
          <Container fullWidth>
            <Panel padding='none'>
                {this.renderPaymentHistory(payments)}
            </Panel>
          </Container>
        </div>
      );
    } else {
      // no  payment history..
      return (<div>No payment history</div>);
    }
  }
}



export default BillingHistory;



// WEBPACK FOOTER //
// ./src/components/pages/Billing/BillingHistory.jsx